<template>
  <base-page-layout title="Faturamento" :filters="['lojas', 'pessoa', 'clube', 'segmentos', 'produtos']">
    <div class="revenue-page d-flex flex-column">
      <data-table :lista="listaFaturamentoMensal" :loading="loading" />
      <historico-faturamento-chart
        :loading="loading"
        :lista-mensal="listaFaturamentoMensal"
        :lista-semanal="listaFaturamentoSemanal"
        :lista-diario="listaFaturamentoDiario"
      />
      <faturamento-anual-chart :lista-mensal="listaFaturamentoMensal" :loading="loading" />
    </div>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import DataTable from '@/modules/empresa/faturamento/views/pages/DataTable.vue'
import FaturamentoAnualChart from '@/modules/empresa/faturamento/views/pages/FaturamentoAnualChart.vue'
import HistoricoFaturamentoChart from '@/modules/empresa/faturamento/views/pages/HistoricoFaturamentoChart.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'

export default {
  components: {
    BasePageLayout,
    DataTable,
    FaturamentoAnualChart,
    HistoricoFaturamentoChart,
  },
  data: () => ({
    listaFaturamentoMensal: [],
    listaFaturamentoSemanal: [],
    listaFaturamentoDiario: [],
    loading: true,
  }),
  computed: {
    ...mapState({
      stateFilters: (state) => state.filters,
    }),
  },
  async mounted() {
    const hasQuickAction = this.$route.query.quick_action
    if (!hasQuickAction) await this.getData()

    this.$nextTick(() => {
      this.$bus.$on('filter', this.getData)
    })
  },
  destroyed() {
    this.$bus.$off('filter')
  },
  methods: {
    ...mapWaitingActions({
      empresaFaturamento: 'faturamento',
    }),
    async getData() {
      const filter = {
        fidelidade: this.stateFilters.fidelidade,
        unidades: this.stateFilters.unitsConfiguration,
        tipo_pessoa: this.stateFilters.pessoa,
        categoria_cliente: this.stateFilters.cliente,
        segmentos: this.stateFilters.segments,
        produto: this.stateFilters.products,
      }

      try {
        this.loading = true
        const [listaFaturamentoMensal, listaFaturamentoSemanal, listaFaturamentoDiario] = await Promise.all([
          this.empresaFaturamento({ group_field: 'ano,mes', ...filter }),
          this.empresaFaturamento({ group_field: 'ano,semana', ...filter }),
          this.empresaFaturamento({ group_field: 'anomesdia', ...filter }),
          this.$store.dispatch('getStates', ['getLastUpdate']),
        ])

        this.listaFaturamentoMensal = listaFaturamentoMensal
        this.listaFaturamentoSemanal = listaFaturamentoSemanal
        this.listaFaturamentoDiario = listaFaturamentoDiario
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.revenue-page {
  gap: 12px;
}
</style>
